import React from "react";
import './Topbar.css';
import ReplyerEmptyFace from '../components/replyEmptyFace'
import { Link, NavLink } from "react-router-dom";
import logo from '../components/logo_2022_02_19_wink_resized.png';
import {BiLogOutCircle} from "react-icons/bi"
import NotificationsButton from '../components/notifications_button'
import ModalLogin from './modalLogin'
import {CgProfile} from "react-icons/cg";
import { useAccount, useDisconnect } from 'wagmi';
import { ReactSession } from 'react-client-session';

function Topbar() { 
    const { address, isConnected } = useAccount()
    const { disconnect } = useDisconnect()
    ReactSession.setStoreType("localStorage");

    var max_block = 0
    if (isConnected) {
        if (ReactSession.get(address)) {
            max_block = ReactSession.get(address);
        }
    } else if (ReactSession.get("smallchains_unsigned")) {
        max_block = ReactSession.get("smallchains_unsigned")
        }
        
        return (
            <header className="Topbar">
                <div className="Topbar-Container">
                    <Link className="SiteBrand" to="/" onClick={()=>{window.scrollTo({ top: 0, behavior: 'smooth' })}}>
                        <img src={logo} alt="" className="logo-top" />
                        <span>
                            <strong>Jérôme Lecoq</strong>
                            <small>neuroscience + notes</small>
                        </span>
                    </Link>

                    <nav className="SiteNavigation" aria-label="Primary navigation">
                        <NavLink end to="/">Overview</NavLink>
                        <NavLink to="/about">About</NavLink>
                        <NavLink to="/projects">Projects</NavLink>
                        <NavLink to="/blog">Blog</NavLink>
                    </nav>

                    <div className="TopbarActions" aria-label="Publishing and wallet controls">
                        {!isConnected?
                            <div className="TopbarButton" title="Connect wallet" aria-label="Connect wallet">
                                <div className="TopbarIcon">
                                    <ModalLogin size="25px"/>
                                </div>
                            </div>
                        :!address?
                            <div className="TopbarButton" title="Connect wallet" aria-label="Connect wallet">
                                <div className="TopbarIcon">
                                    <ModalLogin size="25px"/>
                                </div>
                            </div>
                        :
                            <>
                                <div className="TopbarPosterButton" title="Write a post" aria-label="Write a post">
                                    <ReplyerEmptyFace replytoPostId={0}/>
                                </div>
                                <Link to="/notifications" aria-label="Notifications" title="Notifications">
                                    <div className="TopbarButton" onClick={()=>{window.scrollTo({ top: 0, behavior: 'smooth' })}}>
                                        <div className="TopbarIcon">
                                            <NotificationsButton size={"25px"} key={max_block} blockNumber={max_block} walletAddress={address} />
                                        </div>
                                    </div>
                                </Link>
                                <Link to={"/profile/"+address.toLowerCase()} aria-label="Wallet profile" title="Wallet profile">
                                    <div className="TopbarButton" onClick={()=>{window.scrollTo({ top: 0, behavior: 'smooth' })}}>
                                        <div className="TopbarIcon">
                                            <CgProfile size="25px" />
                                        </div>
                                    </div>
                                </Link>
                                <button className="TopbarButton" type="button" aria-label="Disconnect wallet" title="Disconnect wallet" onClick={() => {
                                    disconnect()
                                }}>
                                    <div className="TopbarIcon">
                                        <BiLogOutCircle size="25px" />
                                    </div>
                                </button>
                            </>
                        }
                    </div>
                </div>
            </header>
    );
}
export default Topbar;
